/* Chula — country/region & language panel
 *
 * Extracted from snippets/chula-locale-panel.liquid on 2026-09-20.
 *
 * It was an inline <script> in the page body, which meant this file's bytes
 * were re-sent and re-parsed on EVERY page of the site and could never be
 * cached. As a theme asset it is fetched once, cached for the session, and
 * `defer` keeps it off the parser's critical path. Nothing else changed —
 * the code below is the inline block verbatim, with its Liquid comments
 * turned into JavaScript ones.
 */

(() => {
    if (customElements.get('chula-locale-panel')) return;

    // Shopify exposes no continent data — ISO 3166 to column, maintained here.
    const REGIONS = {
      eu: 'AD AL AT AX BA BE BG BY CH CY CZ DE DK EE ES FI FO FR GB GG GI GR HR HU IE IM IS IT JE LI LT LU LV MC MD ME MK MT NL NO PL PT RO RS RU SE SI SJ SK SM UA VA XK',
      na: 'AG AI AW BB BL BM BQ BS BZ CA CR CU CW DM DO GD GL GP GT HN HT JM KN KY LC MF MQ MS MX NI PA PM PR SV SX TC TT US VC VG VI',
      sa: 'AR BO BR CL CO EC FK GF GY PE PY SR UY VE',
      mea: 'AE AO BF BH BI BJ BW CD CF CG CI CM CV DJ DZ EG EH ER ET GA GH GM GN GQ GW IL IO IQ JO KE KM KW LB LR LS LY MA MG ML MR MU MW MZ NA NE NG OM PS QA RE RW SA SC SD SH SL SN SO SS ST SZ TD TF TG TN TR TZ UG YE YT ZA ZM ZW',
      ap: 'AF AM AS AU AZ BD BN BT CC CK CX CN FJ FM GE GU HK HM ID IN JP KG KH KI KP KR KZ LA LK MH MM MN MO MP MV MY NC NF NP NR NU NZ PF PG PH PK PN PW SB SG TH TJ TK TL TM TO TV TW UM UZ VN VU WF WS'
    };
    const ORDER = ['eu', 'na', 'sa', 'mea', 'ap'];
    const LOOKUP = {};
    ORDER.forEach((key) => REGIONS[key].split(' ').forEach((code) => { LOOKUP[code] = key; }));

    class ChulaLocalePanel extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-cl-panel]');
        if (!this.panel || this.panel.dataset.clReady) return;
        this.panel.dataset.clReady = '1';

        this.buildColumns();

        // Out of the footer's stacking context.
        document.body.appendChild(this.panel);

        this.card = this.panel.querySelector('.chula-locale__panel');
        this.closeBtn = this.panel.querySelector('.chula-locale__close');
        this.scrollY = 0;
        this.opener = null;

        // Triggers render independently (footer, header, sidebar) — delegate.
        document.addEventListener('click', (e) => {
          const opener = e.target.closest('[data-cl-open]');
          if (!opener) return;
          e.preventDefault();
          // If the mobile sidebar menu is open, close it first so its own
          // page lock doesn't fight ours.
          const sidebar = document.getElementById('sidebar-menu');
          if (sidebar && sidebar.shadowRoot) {
            const sidebarClose = sidebar.shadowRoot.querySelector('[part~="close-button"]');
            if (sidebarClose) sidebarClose.click();
            setTimeout(() => this.open(opener), 60);
            return;
          }
          // Opened from inside one of the side panels (search / wishlist /
          // account). The trigger carries `data-chula-panel-nav`, so that
          // panel closes ITSELF on this same click — but its document
          // listener and ours are both document-level, and the order between
          // them is registration order, not something to rely on. Our lock
          // reads window.scrollY; if it runs while that panel still has the
          // page pinned it reads 0 and the visitor is returned to the top on
          // close. 60ms is the same deferral the wishlist and account drawers
          // use for exactly this, and their close is synchronous, so it lands
          // first. See snippets/chula-panel-nav.liquid for the contract.
          if (opener.hasAttribute('data-chula-panel-nav')) {
            setTimeout(() => this.open(opener), 60);
            return;
          }
          this.open(opener);
        });
        this.panel.querySelectorAll('[data-cl-close]').forEach((el) =>
          el.addEventListener('click', () => this.close()));

        document.addEventListener('keydown', (e) => {
          if (e.key !== 'Escape') return;
          if (!this.panel.hidden) { this.close(); return; }
          if (this.geoEl && !this.geoEl.hidden && this._hideGeo) {
            try { localStorage.setItem('chulaGeoChoice', 'stayed'); } catch (err) {}
            this._hideGeo(false);
          }
        });

        // A line click submits the form; carry its language along.
        this.panel.addEventListener('click', (e) => {
          const item = e.target.closest('[data-cl-item]');
          if (!item) return;

          // Re-picking the current selection would reload into an identical
          // page — that read as "the click did nothing". Just close.
          if (item.dataset.clCountry === this.panel.dataset.currentCountry
              && item.dataset.clLocaleValue === this.panel.dataset.currentLocale) {
            e.preventDefault();
            this.close();
            return;
          }

          const localeInput = this.panel.querySelector('[data-cl-locale]');
          if (localeInput) localeInput.value = item.dataset.clLocaleValue;

          // Visible feedback while the POST + reload run — a country-only
          // switch lands on a page that looks the same (same URL, language,
          // currency), so without this the click felt like a no-op.
          item.classList.add('is-loading');
          this.panel.classList.add('is-submitting');
        });

        // The geolocation prompt opens the same panel.
        window.chulaOpenLocalePanel = (opener) => this.open(opener || null);

        this.geoEl = this.querySelector('[data-geo]');
        this.initGeo();
      }

      // Shared page lock — the panel and the welcome prompt take turns with
      // it, never both. Body leaves flow (iOS), header hidden directly.
      lock(on) {
        const root = document.documentElement;
        if (on) {
          if (root.classList.contains('chula-locale-open')) return;
          this.scrollY = window.scrollY || window.pageYOffset || 0;
          const gap = window.innerWidth - root.clientWidth;
          if (gap > 0) document.body.style.paddingRight = gap + 'px';
          document.body.style.top = (-this.scrollY) + 'px';
          root.classList.add('chula-locale-open');
        } else {
          if (!root.classList.contains('chula-locale-open')) return;
          root.classList.remove('chula-locale-open');
          document.body.style.top = '';
          document.body.style.paddingRight = '';
          window.scrollTo(0, this.scrollY);
        }
      }

      // ── First-visit welcome prompt ────────────────────────────────
      //
      // Takes its turn from window.chulaDialogQueue (defined in
      // snippets/chula-consent.liquid) rather than firing on its own timer,
      // so it never lands on top of the cookie dialog. It must report back
      // exactly once — announce() to ask for a turn, decline() to pass — or
      // the newsletter below it in the queue waits on the watchdog.
      initGeo() {
        const queue = window.chulaDialogQueue;
        const geo = this.geoEl;
        if (!geo) return;
        if (window.Shopify && window.Shopify.designMode) return;

        let choice = null;
        try { choice = localStorage.getItem('chulaGeoChoice'); } catch (e) {}
        if (choice) return;

        const current = (geo.dataset.currentCountry || '').toUpperCase();
        const root = (geo.dataset.root || '').replace(/\/$/, '');

        // Claimed synchronously so the queue knows to expect us before it
        // starts handing out turns.
        if (queue) queue.claim('region');

        let reported = false;
        const report = (fn) => {
          if (reported) return;
          reported = true;
          if (!queue) { if (fn) fn(); return; }
          if (fn) queue.announce('region', fn); else queue.decline('region');
        };

        fetch(root + '/browsing_context_suggestions.json')
          .then((r) => (r.ok ? r.json() : null))
          .then((data) => {
            if (!data) return report(null);
            const d = data.detected_values || {};
            const iso = ((d.country && (d.country.handle || d.country.iso_code)) || d.country_code || '').toUpperCase();
            const name = (d.country && d.country.name) || d.country_name || iso;
            if (!iso || iso === current) return report(null);
            report(() => {
              // A breath after our turn comes up — a prompt that beats the
              // page paint reads as an ambush.
              setTimeout(() => {
                // showGeo can decline (the full panel is already open). If it
                // does, hand the turn straight back or everything queued
                // behind us waits on a dialog that never appeared.
                if (this.showGeo(iso, name) === false && window.chulaDialogQueue) {
                  window.chulaDialogQueue.release('region');
                }
              }, 800);
              return true;
            });
          })
          .catch(() => report(null));
      }

      // Returns false when it declines to show, so the caller can hand the
      // dialog queue back. Returning true unconditionally here stalled the
      // queue outright: the full panel being open makes this a no-op, and
      // the newsletter behind it then waited forever for a release that was
      // never coming.
      showGeo(iso, name) {
        const geo = this.geoEl;
        if (!geo || !this.panel.hidden) return false;

        const body = geo.querySelector('[data-geo-body]');
        body.textContent = (body.dataset.template || '').replace('{country}', name);

        // Same source as the body — the button names the region it sends you
        // to, and the two can't drift apart on what that region is called.
        const acceptBtn = geo.querySelector('[data-geo-accept]');
        acceptBtn.textContent = (acceptBtn.dataset.template || '').replace('{country}', name);

        const remember = (v) => { try { localStorage.setItem('chulaGeoChoice', v); } catch (e) {} };

        // Hand the queue back on every exit from this prompt, so whatever is
        // behind it is not left waiting. Safe to call more than once.
        const releaseQueue = () => {
          if (window.chulaDialogQueue) window.chulaDialogQueue.release('region');
        };

        const hideGeo = (keepLock) => {
          geo.classList.remove('is-open');
          if (!keepLock) this.lock(false);
          clearTimeout(this._geoTimer);
          this._geoTimer = setTimeout(() => { geo.hidden = true; }, 700);
          releaseQueue();
        };
        this._hideGeo = hideGeo;

        geo.querySelectorAll('[data-geo-stay]').forEach((el) =>
          el.addEventListener('click', () => { remember('stayed'); hideGeo(false); }));

        geo.querySelector('[data-geo-other]').addEventListener('click', () => {
          remember('browsed');
          // Straight into the full panel — the lock stays on across the swap.
          geo.classList.remove('is-open');
          geo.hidden = true;
          releaseQueue();
          this.showPanel();
        });

        geo.querySelector('[data-geo-accept]').addEventListener('click', () => {
          remember('accepted');
          let map = {};
          try { map = JSON.parse(geo.dataset.localeMap || '{}'); } catch (e) {}
          const loc = map[iso] || 'en';

          // Prefer the panel's own line (keeps every behaviour identical);
          // fall back to a direct form submit for non-featured countries.
          const line = this.panel.querySelector('[data-cl-country="' + iso + '"][data-cl-locale-value="' + loc + '"]')
            || this.panel.querySelector('[data-cl-country="' + iso + '"]');
          if (line) { line.click(); return; }

          const form = this.panel.querySelector('form');
          if (!form) return;
          const localeInput = this.panel.querySelector('[data-cl-locale]');
          if (localeInput) localeInput.value = loc;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'country_code';
          input.value = iso;
          form.appendChild(input);
          form.submit();
        });

        this.lock(true);
        geo.hidden = false;
        void geo.offsetHeight;
        geo.classList.add('is-open');
        try { geo.querySelector('.chula-geo__close').focus({ preventScroll: true }); } catch (e) {}
        return true;
      }

      buildColumns() {
        const columns = this.panel.querySelector('[data-cl-columns]');
        const source = this.panel.querySelector('[data-cl-source]');
        if (!columns || !source) return;

        const lists = {};
        ORDER.forEach((key) => {
          const region = document.createElement('div');
          region.className = 'chula-locale__region' + (key === 'eu' ? ' chula-locale__region--eu' : '');
          const title = document.createElement('p');
          title.className = 'chula-locale__region-title';
          title.textContent = columns.dataset['label' + key.charAt(0).toUpperCase() + key.slice(1)] || '';
          const list = document.createElement('div');
          list.className = 'chula-locale__region-list';
          region.appendChild(title);
          region.appendChild(list);
          columns.appendChild(region);
          lists[key] = list;
        });

        // Source order is alphabetical in the current locale; moving in
        // order keeps each column alphabetical too.
        Array.prototype.slice.call(source.querySelectorAll('[data-cl-item]')).forEach((item) => {
          const key = LOOKUP[item.dataset.clCountry] || 'ap';
          lists[key].appendChild(item);
        });

        source.remove();
      }

      open(opener) {
        this.opener = opener || null;
        this.lock(true);
        this.showPanel();
      }

      showPanel() {
        this.panel.hidden = false;
        // Reflow, not rAF — rAF does not fire in hidden/throttled tabs.
        void this.panel.offsetHeight;
        this.panel.classList.add('is-open');

        /* Null opener: this panel already returns focus to this.opener in
           close(). The trap is here only to contain Tab inside the panel. */
        if (window.chulaFocusTrap) window.chulaFocusTrap.activate(this.panel, null);

        try { this.closeBtn.focus({ preventScroll: true }); } catch (e) { this.closeBtn.focus(); }
      }

      close() {
        if (window.chulaFocusTrap) window.chulaFocusTrap.release(this.panel);
        this.panel.classList.remove('is-open');
        this.lock(false);

        clearTimeout(this._hideTimer);
        this._hideTimer = setTimeout(() => { this.panel.hidden = true; }, 700);

        if (this.opener && this.opener.isConnected) {
          try { this.opener.focus({ preventScroll: true }); } catch (e) { this.opener.focus(); }
        }
        this.opener = null;
      }
    }

    customElements.define('chula-locale-panel', ChulaLocalePanel);
  })();
